export const HEADER_1_CONSTANTS = {
    DEFAULT_ROW: {
        id: "1",
        status: true,
        background_color: "#ffffff",
        logo: "",
        logo_alt_text: "University Logo",
        promotional_text: "Admissions Open ",
        promotional_text_color: "#ffffff",
        promotional_text_bg_color: "#BE2330",
        phone_icon: "",
        phone_number: "0000",
        phone_number_text_color: "#BE2330",
        button_name: "Apply Now",
        button_link: "#apply",
        button_icon: "",
        button_color: "#BE2330",
        button_text_color: "#ffffff"
    },

    HEADER_FIELDS_CONFIG: [
        {
            fieldName: "status",
            label: "Header Status",
            value: true,
            valueType: "boolean",
            filedType: "TOGGLE",
            placeholder: "Enter Header Status",
        },
        {
            fieldName: "background_color",
            label: "Container Base Background Color",
            value: "#ffffff",
            valueType: "string",
            filedType: "COLOR",
            placeholder: "Enter background color (e.g., #ffffff)",
        },
        {
            fieldName: "logo",
            label: "Logo",
            value: "",
            valueType: "string",
            filedType: "FILE",
            placeholder: "Upload Logo",
        },
        {
            fieldName: "logo_alt_text",
            label: "Logo Alt Text",
            value: "University Logo",
            valueType: "string",
            filedType: "INPUT",
            placeholder: "Enter alt text for logo",
        },
        {
            fieldName: "promotional_text",
            label: "Promotional Text",
            value: "Admissions Open for 2025",
            valueType: "string",
            filedType: "INPUT",
            placeholder: "Enter promotional text (e.g., Admissions are open)",
        },
        {
            fieldName: "promotional_text_color",
            label: "Promotional Text Color",
            value: "#ffffff",
            valueType: "string",
            filedType: "COLOR",
            placeholder: "Enter promotional text color (e.g., #ffffff)",
        },
        {
            fieldName: "promotional_text_bg_color",
            label: "Promotional Text Background Color",
            value: "#BE2330",
            valueType: "string",
            filedType: "COLOR",
            placeholder: "Enter promotional text background color (e.g., #BE2330)",
        },
        {
            fieldName: "phone_icon",
            label: "Phone Icon",
            value: "",
            valueType: "string",
            filedType: "FILE",
            placeholder: "Upload Phone Icon",
        },
        {
            fieldName: "phone_icon_alt",
            label: "Phone Icon Alt Text",
            value: "Phone",
            valueType: "string",
            filedType: "INPUT",
            placeholder: "Enter alt text for phone icon",
        },
        {
            fieldName: "phone_number",
            label: "Phone Number",
            value: "0000",
            valueType: "string",
            filedType: "INPUT",
            placeholder: "Enter phone number",
        },
        {
            fieldName: "phone_number_text_color",
            label: "Phone Number Text Color",
            value: "#BE2330",
            valueType: "string",
            filedType: "COLOR",
            placeholder: "Enter phone number text color (e.g., #BE2330)",
        },
        {
            fieldName: "button_name",
            label: "Button Name",
            value: "Apply Now",
            valueType: "string",
            filedType: "INPUT",
            placeholder: "Enter button text (e.g., Apply Now)",
        },
        {
            fieldName: "button_link",
            label: "Button Link",
            value: "#apply",
            valueType: "string",
            filedType: "INPUT",
            placeholder: "Enter button link URL",
        },
        {
            fieldName: "button_icon",
            label: "Button Icon",
            value: "",
            valueType: "string",
            filedType: "FILE",
            placeholder: "Upload Button Icon",
        },
        {
            fieldName: "button_icon_alt",
            label: "Button Icon Alt Text",
            value: "Button icon",
            valueType: "string",
            filedType: "INPUT",
            placeholder: "Enter alt text for button icon",
        },
        {
            fieldName: "button_color",
            label: "Button Color",
            value: "#BE2330",
            valueType: "string",
            filedType: "COLOR",
            placeholder: "Enter button color (e.g., #BE2330)",
        },
        {
            fieldName: "button_text_color",
            label: "Button Text Color",
            value: "#ffffff",
            valueType: "string",
            filedType: "COLOR",
            placeholder: "Enter button text color (e.g., #ffffff)",
        }
    ],
}